import { createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "custom-modal-overlay" }, null, -1)
const _hoisted_3 = { class: "custom-modal" }
const _hoisted_4 = { class: "custom-modal-dialog" }
const _hoisted_5 = { class: "custom-modal-content text-center" }
const _hoisted_6 = { class: "msg-header" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    class: "bi bi-check-circle",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"
    })
  ])
], -1)
const _hoisted_9 = { class: "msg-body" }
const _hoisted_10 = { class: "text-xl font-semibold text-gray-800 mb-2" }
const _hoisted_11 = {
  key: 0,
  class: "text-gray-600 mb-2"
}
const _hoisted_12 = {
  key: 1,
  class: "text-gray-600"
}
const _hoisted_13 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.state.ui.isActive.customModal)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                (!_ctx.hideCloseButton)
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      type: "button",
                      class: "close",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeSuccessfulModal && _ctx.closeSuccessfulModal(...args))),
                      onKeydown: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeSuccessfulModal && _ctx.closeSuccessfulModal(...args)), ["esc"])),
                      "aria-label": "Close"
                    }, [
                      _hoisted_7
                    ], 32))
                  : _createCommentVNode("", true),
                _hoisted_8
              ]),
              _createVNode("div", _hoisted_9, [
                _createVNode("h3", _hoisted_10, _toDisplayString(_ctx.props.title ? _ctx.props.title : _ctx.$t('successful')), 1),
                (_ctx.titleMessage)
                  ? (_openBlock(), _createBlock("p", _hoisted_11, _toDisplayString(_ctx.$t(_ctx.titleMessage)), 1))
                  : _createCommentVNode("", true),
                (_ctx.subTitleMessage)
                  ? (_openBlock(), _createBlock("p", _hoisted_12, _toDisplayString(_ctx.$t(_ctx.subTitleMessage)), 1))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_13, [
                  _renderSlot(_ctx.$slots, "default")
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}